import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountStore } from './account-store';
import { PdRoutes } from './routes';

@Injectable({
  providedIn: 'root',
})
export class UnauthGuard {
  constructor(private pdRoutes: PdRoutes, private accountStore: AccountStore) {}

  canActivate():
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const token = this.accountStore.accessToken;
    const isUnauthenticated = !token;
    if (!isUnauthenticated) {
      return this.pdRoutes.my.root().urlTree;
    }
    return isUnauthenticated;
  }
}
